import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";

// create slice

const name = "inbox";
const initialState = createInitialState();
const extraActions = createExtraActions();
const slice = createSlice({
  name,
  initialState,
  extraReducers: (builder) => {
    createExtraReducers(builder, extraActions);
  },
});

// exports

export const inboxActions = { ...slice.actions, ...extraActions };
export const inboxReducer = slice.reducer;

// implementation

const formatDateTime = (date) => {
  if (!date) return "";

  const d = new Date(date);

  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  const year = d.getFullYear();

  let hours = d.getHours();
  const minutes = String(d.getMinutes()).padStart(2, "0");

  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12; // convert 0 → 12

  return `${month}/${day}/${year} ${String(hours).padStart(2, "0")}:${minutes} ${ampm}`;
};

function createInitialState() {
  return {
    ArchiveinboxMessagesList: [],
    PublicInboxMessageSubjectList: [],
    inmateInboxMessageHistoryList: [],
    LoadPublicMyContactsDisplayList: [],
    InmateInboxMessageResponse: [],
    InmateFreeCreditBalanceResult: [],
    CactasServiceDetailsResult: [],
    InmatePublicCreditBalanceResultResult: [],
    UpdateMessageCactaCreditResult: [],
    SendMessageResult: [],
    UpdateCODMessageResult: [],
    InsertUpdateUspInmateInboxMessageDeleteResult: [],
    InsertUpdateInmateInboxMessageReadResult: [],
    InboxSendMessageResult: []
  };
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}`;


  return {
    LoadInmateInboxArchiveMessage: LoadInmateInboxArchiveMessage(),
    LoadInmateInboxMessageSubject: LoadInmateInboxMessageSubject(),
    LoadInmateInboxMessageHistory: LoadInmateInboxMessageHistory(),
    LoadPublicMyContactsDisplay: LoadPublicMyContactsDisplay(),
    LoadInmateInboxMessage: LoadInmateInboxMessage(),
    LoadInmateFreeCreditBalanceResult: LoadInmateFreeCreditBalanceResult(),
    LoadCactasServiceDetailsResult: LoadCactasServiceDetailsResult(),
    LoadInmatePublicCreditBalanceResult: LoadInmatePublicCreditBalanceResult(),
    LoadUpdateMessageCactaCredit: LoadUpdateMessageCactaCredit(),
    LoadSendMessage: LoadSendMessage(),
    LoadSendNotificationandEmail: LoadSendNotificationandEmail(),
    LoadUpdateCODMessage: LoadUpdateCODMessage(),
    LoadInsertUpdateUspInmateInboxMessageDelete: LoadInsertUpdateUspInmateInboxMessageDelete(),
    LoadInsertUpdateInmateInboxMessageRead: LoadInsertUpdateInmateInboxMessageRead(),
    LoadInboxSendMessage: LoadInboxSendMessage(),
    LoadInmateBalance: LoadInmateBalance(),
  };


  function LoadInmateBalance() {
    return createAsyncThunk(
      `${name}/LoadInmateBalance`,
      async ({ cactasURL, cactasAccessKey, residentID }) =>
        await fetchWrapper.get(`${baseUrl}/Kiosk/MyMessage/LoadInmateBalance?cactasURL=${cactasURL}&cactasAccessKey=${cactasAccessKey}&residentID=${residentID}`)
    );
  }


  function LoadInboxSendMessage() {
    return createAsyncThunk(
      `${name}/LoadInboxSendMessage`,
      async (objData) =>
        await fetchWrapper.post(`${baseUrl}/Kiosk/MyMessage/InboxSendMessage`, objData)
    );
  }


  function LoadInsertUpdateInmateInboxMessageRead() {
    return createAsyncThunk(
      `${name}/LoadInsertUpdateInmateInboxMessageRead`,
      async ({ inmatesId, messageID }) =>
        await fetchWrapper.post(`${baseUrl}/Kiosk/MyMessage/InsertUpdateInmateInboxMessageRead?inmatesId=${inmatesId}&messageID=${messageID}`)
    );
  }

  function LoadInsertUpdateUspInmateInboxMessageDelete() {
    return createAsyncThunk(
      `${name}/LoadInsertUpdateUspInmateInboxMessageDelete`,
      async ({ inmatesId, messageID, facilityID }) =>
        await fetchWrapper.post(`${baseUrl}/Kiosk/MyMessage/InsertUpdateUspInmateInboxMessageDelete?inmatesId=${inmatesId}&messageID=${messageID}&facilityID=${facilityID}`)
    );
  }

  function LoadUpdateCODMessage() {
    return createAsyncThunk(
      `${name}/LoadUpdateCODMessage`,
      async (objData) =>
        await fetchWrapper.post(`${baseUrl}/Kiosk/MyMessage/UpdateCODMessage`, objData)
    );
  }

  function LoadSendMessage() {
    return createAsyncThunk(
      `${name}/LoadSendMessage`,
      async (objData) =>
        await fetchWrapper.post(`${baseUrl}/Kiosk/MyMessage/SendMessage`, objData)
    );
  }

  function LoadSendNotificationandEmail() {
    return createAsyncThunk(
      `${name}/LoadSendNotificationandEmail`,
      async (objData) =>
        await fetchWrapper.post(`${baseUrl}/Kiosk/MyMessage/SendNotificationandEmail`, objData)
    );
  }

  function LoadUpdateMessageCactaCredit() {
    return createAsyncThunk(
      `${name}/LoadUpdateMessageCactaCredit`,
      async (objData) =>
        await fetchWrapper.post(`${baseUrl}/Kiosk/MyMessage/UpdateMessageCactaCredit`, objData)
    );
  }

  function LoadInmateInboxArchiveMessage() {
    return createAsyncThunk(
      `${name}/LoadPublicInboxMessageWeb`,
      async (params) =>
        await fetchWrapper.post(`${baseUrl}/Kiosk/MyMessage/InmateInboxArchiveMessage`, params)

    );
  }

  function LoadInmateInboxMessage() {
    return createAsyncThunk(
      `${name}/LoadInmateInboxMessage`,
      async (objData) =>
        await fetchWrapper.post(`${baseUrl}/Kiosk/MyMessage/LoadInmateInboxMessage`, objData)
    );
  }

  // BindUserCredits
  function LoadInmatePublicCreditBalanceResult() {
    return createAsyncThunk(
      `${name}/LoadInmatePublicCreditBalanceResult`,
      async ({ inmatesId, userId, pUIConnectionID }) =>
        await fetchWrapper.post(`${baseUrl}/Kiosk/MyMessage/InmatePublicCreditBalanceResult?inmatesId=${inmatesId}&userId=${userId}&pUIConnectionID=${pUIConnectionID}`)
    );
  }

  // BindFreeCredits
  function LoadInmateFreeCreditBalanceResult() {
    return createAsyncThunk(
      `${name}/LoadInmateFreeCreditBalanceResult`,
      async ({ inmateResidentID, facilityId }) =>
        await fetchWrapper.post(`${baseUrl}/Kiosk/MyMessage/InmateFreeCreditBalanceResult?inmateResidentID=${inmateResidentID}&facilityId=${facilityId}`)
    );
  }

  //BindCACTASDetails
  function LoadCactasServiceDetailsResult() {
    return createAsyncThunk(
      `${name}/LoadCactasServiceDetailsResult`,
      async ({ facilityId }) =>
        await fetchWrapper.post(`${baseUrl}/Kiosk/MyMessage/CactasServiceDetailsResult?facilityId=${facilityId}`)
    );
  }

  function LoadInmateInboxMessageSubject() {
    return createAsyncThunk(
      `${name}/PublicInboxMessageSubject`,
      async ({ MessageID, inmatesId }) =>
        await fetchWrapper.post(
          `${baseUrl}/Kiosk/MyMessage/LoadInmateInboxMessageSubject?messageId=${MessageID}&inmatesId=${inmatesId}`
        )

    );
  }

  function LoadInmateInboxMessageHistory() {
    return createAsyncThunk(
      `${name}/PublicInboxMessageHistory`,
      async ({ MessageID, isHoldCOD, pageNo, rowCountPerPage }) =>
        await fetchWrapper.post(
          `${baseUrl}/Kiosk/MyMessage/LoadInmateInboxMessageHistory?messageId=${MessageID}&isHoldCOD=${isHoldCOD}&pageNo=${pageNo}&rowCountPerPage=${rowCountPerPage}`
        )

    );
  }

  function LoadPublicMyContactsDisplay() {
    return createAsyncThunk(
      `${name}/LoadPublicMyContactsDisplay`,
      async ({ userId, inmatesId, activeStatus, inmateLoadPurpose, sortField }) =>
        await fetchWrapper.get(
          `${baseUrl}/Kiosk/MyMessage/LoadPublicMyContactsDisplay?userId=${userId}&inmatesId=${inmatesId}&activeStatus=${activeStatus}&inmateLoadPurpose=${inmateLoadPurpose}&sortField=${sortField}`
        )
    );
  }

}

function createExtraReducers(builder, actions) {
  builder
    .addCase(actions.LoadInboxSendMessage.pending, (state) => {
      state.InboxSendMessageResult = [];
    })
    .addCase(actions.LoadInboxSendMessage.fulfilled, (state, action) => {
      state.InboxSendMessageResult = action.payload;
    })
    .addCase(actions.LoadInboxSendMessage.rejected, (state, action) => {
      state.InboxSendMessageResult = { error: action.error };
    })
    .addCase(actions.LoadInsertUpdateInmateInboxMessageRead.pending, (state) => {
      state.InsertUpdateInmateInboxMessageReadResult = [];
    })
    .addCase(actions.LoadInsertUpdateInmateInboxMessageRead.fulfilled, (state, action) => {
      state.InsertUpdateInmateInboxMessageReadResult = action.payload;
    })
    .addCase(actions.LoadInsertUpdateInmateInboxMessageRead.rejected, (state, action) => {
      state.InsertUpdateInmateInboxMessageReadResult = { error: action.error };
    })
    .addCase(actions.LoadInsertUpdateUspInmateInboxMessageDelete.pending, (state) => {
      state.InsertUpdateUspInmateInboxMessageDeleteResult = [];
    })
    .addCase(actions.LoadInsertUpdateUspInmateInboxMessageDelete.fulfilled, (state, action) => {
      state.InsertUpdateUspInmateInboxMessageDeleteResult = action.payload;
    })
    .addCase(actions.LoadInsertUpdateUspInmateInboxMessageDelete.rejected, (state, action) => {
      state.InsertUpdateUspInmateInboxMessageDeleteResult = { error: action.error };
    })
    .addCase(actions.LoadUpdateCODMessage.pending, (state) => {
      state.UpdateCODMessageResult = [];
    })
    .addCase(actions.LoadUpdateCODMessage.fulfilled, (state, action) => {
      state.UpdateCODMessageResult = action.payload;
    })
    .addCase(actions.LoadUpdateCODMessage.rejected, (state, action) => {
      state.UpdateCODMessageResult = { error: action.error };
    })
    .addCase(actions.LoadSendMessage.pending, (state) => {
      state.SendMessageResult = [];
    })
    .addCase(actions.LoadSendMessage.fulfilled, (state, action) => {
      state.SendMessageResult = action.payload;
    })
    .addCase(actions.LoadSendMessage.rejected, (state, action) => {
      state.SendMessageResult = { error: action.error };
    })
    .addCase(actions.LoadUpdateMessageCactaCredit.pending, (state) => {
      state.UpdateMessageCactaCreditResult = [];
    })
    .addCase(actions.LoadUpdateMessageCactaCredit.fulfilled, (state, action) => {
      state.UpdateMessageCactaCreditResult = action.payload;
    })
    .addCase(actions.LoadUpdateMessageCactaCredit.rejected, (state, action) => {
      state.UpdateMessageCactaCreditResult = { error: action.error };
    })
    .addCase(actions.LoadInmateFreeCreditBalanceResult.pending, (state) => {
      state.InmateFreeCreditBalanceResult = [];
    })
    .addCase(actions.LoadInmateFreeCreditBalanceResult.fulfilled, (state, action) => {
      state.InmateFreeCreditBalanceResult = action.payload;
    })
    .addCase(actions.LoadInmateFreeCreditBalanceResult.rejected, (state, action) => {
      state.InmateFreeCreditBalanceResult = { error: action.error };
    })
    .addCase(actions.LoadCactasServiceDetailsResult.pending, (state) => {
      state.CactasServiceDetailsResult = [];
    })
    .addCase(actions.LoadCactasServiceDetailsResult.fulfilled, (state, action) => {
      state.CactasServiceDetailsResult = action.payload;
    })
    .addCase(actions.LoadCactasServiceDetailsResult.rejected, (state, action) => {
      state.CactasServiceDetailsResult = { error: action.error };
    })
    .addCase(actions.LoadInmateInboxMessage.pending, (state) => {
      // state.InmateInboxMessageResponse = [];
    })
    .addCase(actions.LoadInmateInboxMessage.fulfilled, (state, action) => {
      const isScroll = action?.meta?.arg?.isScroll;
      if (isScroll && Array.isArray(state.InmateInboxMessageResponse)) {
        state.InmateInboxMessageResponse = [
          ...state.InmateInboxMessageResponse,
          ...action.payload.map((item) => ({
            ...item, MessageSentDate: item?.MessageSentDate ? new Date(item.MessageSentDate) : null,
            MessageSendDateTime: item?.MessageSendDateTime ? formatDateTime(item.MessageSendDateTime) : null
          }))
        ];
      } else {
        state.InmateInboxMessageResponse = action.payload;
      }
    })
    .addCase(actions.LoadInmateInboxMessage.rejected, (state, action) => {
      state.InmateInboxMessageResponse = { error: action.error };
    })
    .addCase(actions.LoadInmateInboxArchiveMessage.pending, (state) => {
      //state.ArchiveinboxMessagesList = [];
    })
    .addCase(actions.LoadInmateInboxArchiveMessage.fulfilled, (state, action) => {
      const isScroll = action?.meta?.arg?.isScroll;
      if (isScroll && Array.isArray(state.ArchiveinboxMessagesList)) {
        state.ArchiveinboxMessagesList = [
          ...state.ArchiveinboxMessagesList,
          ...action.payload
        ];
      } else {
        state.ArchiveinboxMessagesList = action.payload;
      }
    })
    .addCase(actions.LoadInmateInboxArchiveMessage.rejected, (state, action) => {
      state.ArchiveinboxMessagesList = { error: action.error };
    })
    .addCase(actions.LoadInmateInboxMessageSubject.pending, (state) => {
      state.PublicInboxMessageSubjectList = [];
    })
    .addCase(actions.LoadInmateInboxMessageSubject.fulfilled, (state, action) => {
      state.PublicInboxMessageSubjectList = action.payload;
    })
    .addCase(actions.LoadInmateInboxMessageSubject.rejected, (state, action) => {
      state.PublicInboxMessageSubjectList = { error: action.error };
    })
    .addCase(actions.LoadInmateInboxMessageHistory.pending, (state) => {
      state.inmateInboxMessageHistoryList = [];
    })
    .addCase(actions.LoadInmateInboxMessageHistory.fulfilled, (state, action) => {
      state.inmateInboxMessageHistoryList = action.payload;
    })
    .addCase(actions.LoadInmateInboxMessageHistory.rejected, (state, action) => {
      state.inmateInboxMessageHistoryList = { error: action.error };
    })
    .addCase(actions.LoadPublicMyContactsDisplay.pending, (state) => {
      state.LoadPublicMyContactsDisplayList = [];
    })
    .addCase(actions.LoadPublicMyContactsDisplay.fulfilled, (state, action) => {
      state.LoadPublicMyContactsDisplayList = action.payload;
    })
    .addCase(actions.LoadPublicMyContactsDisplay.rejected, (state, action) => {
      state.LoadPublicMyContactsDisplayList = { error: action.error };
    })
    .addCase(actions.LoadInmatePublicCreditBalanceResult.pending, (state) => {
      state.InmatePublicCreditBalanceResultResult = [];
    })
    .addCase(actions.LoadInmatePublicCreditBalanceResult.fulfilled, (state, action) => {
      state.InmatePublicCreditBalanceResultResult = action.payload;
      state.loading = false;
    })
    .addCase(actions.LoadInmatePublicCreditBalanceResult.rejected, (state, action) => {
      state.InmatePublicCreditBalanceResultResult = { error: action.error };
    });
}
